<h2 mat-dialog-title>
  {{ "subjectModelEditDialog." + (newFlag ? "newSubjectModel" : cloneFlag ? "cloneSubjectModel" : "editSubjectModel") | translate }}
</h2>
<div class="container" fxLayout="column" fxLayoutAlign="start center">
  <div class="form-container" fxLayout="column" fxLayoutGap="5px">
    <!--
      <p> Subject Model Information</p>
      -->
    <mat-form-field>
      <mat-label>{{ "subjectModelEditDialog.namePlaceholder" | translate }}</mat-label>
      <input matInput maxlength="{{ nameMaxLength }}" [formControl]="nameControl" required />
      <mat-hint align="end">{{ nameControl.value?.length || 0 }}/{{ nameMaxLength }}</mat-hint>
      <mat-error *ngIf="nameControl.hasError('required')">
        {{ "subjectModelEditDialog.nameRequired" | translate }}
      </mat-error>
      <mat-error *ngIf="nameControl.hasError('maxlength')"
        >{{ "subjectModelEditDialog.nameMaxLength" | translate: { nameMaxLength: nameMaxLength } }}
      </mat-error>
      <mat-error *ngIf="nameControl.hasError('pattern') && !nameControl.hasError('required')">{{
        "subjectModelEditDialog.nameValid" | translate
      }}</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="!cloneFlag">
      <mat-label>{{ "subjectModelEditDialog.inspectionTypePlaceholder" | translate }}</mat-label>
      <mat-select hideSingleSelectionIndicator [formControl]="inspectionTypeControl" required>
        <mat-option *ngFor="let item of inspectionTypeItems" [value]="item">
          {{ "subjectModelEditDialog.inspectionType_" + item.key | translate }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="inspectionTypeControl.hasError('required')">
        {{ "subjectModelEditDialog.inspectionTypeRequired" | translate }}
      </mat-error>
    </mat-form-field>

    <div fxLayout="row" fxLayoutAlign="start">
      <mat-slide-toggle
        [style.visibility]="!newFlag && !cloneFlag ? 'visible' : 'hidden'"
        color="primary"
        [disabled]="newFlag || cloneFlag || (!uploadImagePath && !subjectModel)"
      >
        <div>{{ toggleText }}</div>
      </mat-slide-toggle>
    </div>
    <div fxFlex></div>
    <div fxLayout="row" fxLayoutAlign="center">
      <mat-dialog-actions>
        <button mat-button color="primary" mat-dialog-close>{{ "subjectModelEditDialog.cancel" | translate }}</button>
        <button mat-raised-button color="primary" [disabled]="isSubmitInValid" (click)="submit()">
          {{ "subjectModelEditDialog.save" | translate }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
